<template>
  <div class="antialiased">
    <Sidebar />

    <div class="page">
      <Header
          @change="_search"
          hint="Ketik keyword"
          @refresh="(filter.keyword = ''), _get()"
          :enabledRefresh="true"
      />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Api Request History</h2>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pb-3">
            <div class="row">
              <div class="col-3">
                <label class="form-label">Tanggal Awal</label>
                <input type="date" v-model="filter.start_date" class="form-control">
              </div>
              <div class="col-3">
                <label class="form-label">Tanggal Akhir</label>
                <input type="date" v-model="filter.end_date" class="form-control">
              </div>
              <div class="col-3">
                <label class="form-label">Status Code</label>
                <select class="form-control" v-model="filter.status_code">
                  <option value="" disabled selected>Select Status Code</option>
                  <option v-for="option in [200, 404, 422, 500]" :value="option">
                    {{option}}
                  </option>
                </select>
              </div>
              <div class="col-3">
                <label class="form-label">&nbsp;</label>
                <button class="btn btn-info" @click="_get">
                  Search
                </button>
              </div>
            </div>
          </div>

          <Skeleton
              type="table"
              :length="10"
              class="mt-3 bg-white"
              v-if="loading"
          />

          <Nodata v-if="!loading && data.length == 0" />

          <div class="box" v-if="!loading && data.length > 0">
            <div class="card" style="max-height: 520px">
              <div class="table-responsive" style="width: 100%">
                <table
                    class="
                    table table-vcenter table-hover
                    card-table
                    table-control
                  "
                >
                  <thead>
                  <tr class="text-muted" style="border-bottom-width: 2px;">
                    <th>Config</th>
                    <th>Request</th>
                    <th>Response</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, i) in data" :key="i" style="border: 1px solid #45aaf2; border-top-width: 2px; border-bottom-width: 2px;">
                    <td style="max-width: 400px; overflow: hidden; text-overflow: ellipsis;">
                      <tr>
                        <td>Url</td>
                        <td>{{row.url}}</td>
                      </tr>
                      <tr>
                        <td>Method</td>
                        <td>{{row.method}}</td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td>
                          <span :class="'btn '+ (
                              row.response_status_code > 500 ? 'btn-warning' :
                              row.response_status_code > 400 ? 'btn-danger' :
                              row.response_status_code>200 ? 'btn-success' :
                              'btn-info')
                          ">
                            {{row.response_status_code}}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Duration</td>
                        <td>{{row.duration}}</td>
                      </tr>
                      <tr>
                        <td>Created At</td>
                        <td>{{row.created_at}}</td>
                      </tr>
                      <tr>
                        <td>Call Attempt</td>
                        <td>
                          {{row.call_attempt}}
                        </td>
                      </tr>
                      <tr>
                        <td>Retry Hit Api</td>
                        <td>
                          <button class="btn btn-warning" @click="_confirm(row)" v-html="ic('refresh') + 'Retry Hit'"></button>
                        </td>
                      </tr>
                    </td>
                    <td>
                      <tr v-for="(value, header) in JSON.parse(row.request_headers)" :key="header">
                        <td>{{ header }}</td>
                        <td>{{ value }}</td>
                      </tr>
                      <hr>
                      <tr v-for="(value, header) in JSON.parse(row.request_body)" :key="header">
                        <td>{{ header }}</td>
                        <td>{{ value }}</td>
                      </tr>
                    </td>
                    <td>
                      <tr v-for="(value, header) in JSON.parse(row.response_headers)" :key="header">
                        <td>{{ header }}</td>
                        <td>{{ value }}</td>
                      </tr>
                      <hr>
                      <tr v-for="(value, header) in JSON.parse(row.response_body)" :key="header">
                        <td>{{ header }}</td>
                        <td>{{ value }}</td>
                      </tr>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Confirm
        :id.sync="confirm.id"
        :title.sync="confirm.title"
        :sub-title.sync="confirm.subtitle"
        :isSubmit.sync="confirm.isSubmit"
        :text-confirm.sync="confirm.textConfirm"
        @submit="confirm.action"
    />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "Users",

  data() {
    return {
      auth: {},
      loading: true,
      data: [],
      confirm: {
        id:null,
        title: null,
        subtitle:null,
        textConfirm:null,
        isSubmit: false,
        action: () => {}
      },
      filter: {
        keyword: "",
        start_date: helper.methods.dateTime('ymd'),
        end_date: helper.methods.dateTime('ymd'),
        status_code : "",
      },
    };
  },

  mixins: [helper],

  methods: {
    _get() {
      this.loading = true;
      this.axios
          .get("api_request/histories", {
            params: this.filter
          })
          .then((res) => {
            this.loading = false;
            this.data = res.data.data;
          })
          .catch((err) => {
            this.loading = false;
            this.onError(err);
          });
    },

    _filter() {
      this.filter.config = { view: true, title: "Filter" };
      this.filter.action = (formData) => {
        for (const key in formData) {
          this.filter[key] = formData[key];
        }

        this._get();
      };
    },

    _confirm(data){
      this.confirm.id = data.id
      this.confirm.title = 'Are you sure you want to execute this API call again?';
      this.confirm.subtitle = 'The system will resend the request to the target API using the stored request.';
      this.confirm.textConfirm = 'Yes, Execute Now!';
      this.confirm.action = async () => {
        try{
          const response = await this.axios.post('api_request/retry', data)
          this.toast(response.data.message);
          this.confirm.id = null
          this._get()
        }catch(error) {
          this.onError(err);
          this.toast(error);
          this.confirm.isSubmit = false
        }
      }
    },

    _search(keyword) {
      this.filter.keyword = keyword;
      this._get();
    },
  },

  mounted() {
    this.auth = JSON.parse(localStorage.user);
    this._get();
  },
};
</script>
